import QRCode from 'qrcode'

export default {
  data () {
    return {
      // type 1 赠送者 2 领取者 3 游客
      type: 0,
      typeText: ['', '赠出', '受赠'],
      code: '',
      qrcodeUrl: '',
      // detail.status 1 赠送中 2 已领取 3 已撤销
      detail: {},
      statsText: ['', '转赠中', '转赠成功', '撤销转赠'],
      errMsg: '',
      flag: 0
    }
  },
  async created () {
    this.type = this.$route.query.type * 1
    this.code = this.$route.query.code
    if (this.code) {
      await this.fetchDetail()
      if (this.detail.status === 1) {
        await this.getQRCode()
      }
      this.flag += 1
    }
  },
  methods: {
    async fetchDetail () {
      this.$toast.loading()
      const payload = {
        code: this.code,
        type: this.type
      }
      const res = await this.$axios.post('api/member/account_experience_gift_info', payload)
      this.$toast.clear()
      const { code, data, msg } = res.data
      if (code === 0) {
        this.detail = data
        this.detail.status = this.detail.status * 1
      } else {
        this.errMsg = msg
        this.$toast(msg)
      }
    },
    async getQRCode () {
      if (this.detail.status !== 1) return
      // L (Low) ~7%
      // M (Medium) ~15%
      // Q (Quartile) ~25%
      // H (High) ~30%
      const options = {
        errorCorrectionLevel: 'L'
      }
      const info = `${process.env.VUE_APP_BASE_URL}EGReceive?code=${this.detail.code}&type=3`
      const url = await QRCode.toDataURL(info, options)
      this.qrcodeUrl = url
    }
  }
}
